exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll[data-v-15179d47]{height:100%;width:100%;overflow:hidden;background:#eee}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15179d47","scoped":true,"hasInlineConfig":false}!./node_modules/_stylus-loader@3.0.2@stylus-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/packages/components/Scroll.vue
// module id = 28
// module chunks = 0